const Staff = {
  path: "",
  name: "",
  redirect: "/manageStaff",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/manageStaff",
      redirect: "/manageStaff",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Staff Management",
      meta: {
        requiresAuth: true,
        activeUrl: "/manageStaff",
        parent: "staff",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/manageStaff"),
          meta: {
            requiresAuth: true,
            activeUrl: "/manageStaff",
            parent: "staff",

            lv: 2,
          },
        },
        {
          path: "detail/:id",
          name: "Staff Management Detail",
          component: () => import("@/views/pages/manageStaff/Detail.vue"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/manageStaff",
            parent: "staff",
            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default Staff;
